import { useTranslation } from 'react-i18next'
import './LanguageSwitcher.css'

/**
 * 🌐 Globe toggle that switches between English and Arabic.
 * Positioned in the top corner — flips automatically in RTL.
 */
export default function LanguageSwitcher() {
  const { i18n } = useTranslation()

  const toggle = () => {
    const next = i18n.language === 'ar' ? 'en' : 'ar'
    i18n.changeLanguage(next)
  }

  return (
    <button
      className="language-switcher"
      onClick={toggle}
      aria-label={i18n.language === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
      title={i18n.language === 'ar' ? 'English' : 'عربي'}
    >
      <span className="language-switcher-icon">🌐</span>
      <span className="language-switcher-label">
        {i18n.language === 'ar' ? 'EN' : 'عربي'}
      </span>
    </button>
  )
}
